import * as React from 'react';
import { IconActionArrowLeft16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './style.css';

export interface ILeftArrowProps {
  onClick: () => void;
}

export const LeftArrow: React.FC<ILeftArrowProps> = ({ onClick }) => {
  return (
    <div className={style['item']} onClick={onClick}>
      <IconActionArrowLeft16 color="icon-secondary-default" />
    </div>
  );
};
